import classNames from 'classnames';
import styled from 'styled-components';
import { variants, sizes } from './style';

export interface LogoProps {
  className?: string;
  variant?: keyof typeof variants;
  size?: keyof typeof sizes;
}

const LogoComponent = ({ className }: LogoProps) => (
  <span className={classNames('box-logo', className)}>
    <svg
      role="img"
      aria-label="Gloat Logo"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 671.2 461.4"
      //@ts-expect-error
      alt={'logo'}
    >
      <polygon className="st0" points="576.6,166.2 529.7,166.2 529.7,85.6 529.7,85.6 576.6,85.6 " />
      <rect
        x="609.1"
        y="46.1"
        transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 718.1677 -546.9277)"
        className="st0"
        width="47"
        height="79.1"
      />
      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="609.122" y1="85.9057" x2="669.0711" y2="85.1746">
        <stop offset="0" />
        <stop offset="0.8025" />
      </linearGradient>
      <polygon className="st1" points="593,109.1 593,62.1 672.1,62.1 672.1,109.1 " />
      <path className="st0" d="M576.6,247.7L576.6,247.7c-26,0-47-21-47-47v-29.2h0h47V247.7z" />
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="553.7158"
        y1="191.6016"
        x2="551.812"
        y2="252.5248"
      >
        <stop offset="0" />
        <stop offset="0.8025" />
      </linearGradient>
      <path className="st2" d="M576.6,247.7L576.6,247.7c-26,0-47-21-47-47v-29.2h0h47V247.7z" />
      <g>
        <path
          className="st0"
          d="M128.4,318l-0.1-46.9H96.1c-52.6,0-95.2,42.6-95.2,95.2c0,52.6,42.6,95.2,95.2,95.2s95.2-42.6,95.2-95.2V171.5
		h-47v194.7c0,26.6-21.6,48.2-48.2,48.2s-48.2-21.6-48.2-48.2c0-26.6,21.7-48.2,48.3-48.2H128.4z"
        />
        <linearGradient
          id="SVGID_3_"
          gradientUnits="userSpaceOnUse"
          x1="167.7354"
          y1="258.9228"
          x2="167.7354"
          y2="330.8077"
        >
          <stop offset="0" />
          <stop offset="0.5331" />
          <stop offset="1" />
        </linearGradient>
        <rect x="144.2" y="260" className="st3" width="47" height="107.9" />
        <linearGradient
          id="SVGID_4_"
          gradientUnits="userSpaceOnUse"
          x1="146.0811"
          y1="199.8843"
          x2="188.492"
          y2="255.4223"
        >
          <stop offset="0" />
          <stop offset="0.8025" />
        </linearGradient>
        <rect x="144.2" y="185.4" className="st4" width="47" height="85.8" />
        <path
          className="st0"
          d="M110.7,86.6c-44.5,0-80.6,36.1-80.6,80.6s36.1,80.6,80.6,80.6s80.6-36.1,80.6-80.6S155.2,86.6,110.7,86.6z
		 M110.7,200.7c-18.5,0-33.6-15-33.6-33.6c0-18.5,15-33.6,33.6-33.6s33.6,15,33.6,33.6C144.2,185.7,129.2,200.7,110.7,200.7z"
        />
        <linearGradient
          id="SVGID_5_"
          gradientUnits="userSpaceOnUse"
          x1="171.8631"
          y1="178.3439"
          x2="146.9474"
          y2="144.0849"
        >
          <stop offset="0" />
          <stop offset="0.8025" />
        </linearGradient>
        <path
          className="st5"
          d="M171.1,220.4c12.5-14.2,20.1-32.8,20.1-53.2c0-44.5-36.1-80.6-80.6-80.6v47c18.5,0,33.6,15,33.6,33.6
		c0,8.1-2.9,15.5-7.7,21.3c-0.7,0.8-1.4,1.6-2.2,2.4"
        />
        <polygon className="st0" points="233.7,92.2 233.4,91.9 134.5,190.8 167.7,224.1 233.7,158.1 	" />
        <linearGradient
          id="SVGID_6_"
          gradientUnits="userSpaceOnUse"
          x1="227.1633"
          y1="155.1883"
          x2="157.7119"
          y2="162.542"
        >
          <stop offset="0" />
          <stop offset="0.8025" />
        </linearGradient>
        <polygon className="st6" points="233.7,92.2 233.4,91.9 134.5,190.8 167.7,224.1 233.7,158.1 	" />
        <g>
          <path
            className="st0"
            d="M279.3,200c-3.1,0.7-6.3,0.9-9.6,0.6c-17.6-1.4-30.9-16.4-30.9-34V47.5c0-26-21-47-47-47h0h0v165.7
			c0,44.5,36.4,81.6,80.9,81.4c14.5-0.1,28.2-4,39.9-10.8C298,228.5,286.3,215.5,279.3,200z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGID_7_"
            gradientUnits="userSpaceOnUse"
            x1="279.4921"
            y1="189.626"
            x2="242.2382"
            y2="206.8201"
          >
            <stop offset="0" />
            <stop offset="0.8025" />
          </linearGradient>
          <path
            className="st7"
            d="M279.3,200c-2.3,0.5-4.6,0.7-7,0.7c-18.5,0-33.6-15-33.6-33.6h-47c0,44.5,36.1,80.6,80.6,80.6
			c14.7,0,28.4-3.9,40.3-10.8C298,228.5,286.3,215.5,279.3,200z"
          />
        </g>
      </g>
      <path
        className="st0"
        d="M358.7,190.9c-13.1,13.1-34.4,13.1-47.5,0c-13.1-13.1-13.1-34.4,0-47.5L278,110.2c-31.5,31.5-31.5,82.5,0,113.9
	s82.5,31.5,113.9,0L358.7,190.9z"
      />
      <path className="st0" d="M392.1,224.1" />
      <path className="st0" d="M476,140.2" />
      <path
        className="st0"
        d="M335,86.6c-44.5,0-80.6,36.1-80.6,80.6s36.1,80.6,80.6,80.6s80.6-36.1,80.6-80.6S379.5,86.6,335,86.6z
	 M335,200.7c-18.5,0-33.6-15-33.6-33.6c0-18.5,15-33.6,33.6-33.6s33.6,15,33.6,33.6C368.6,185.7,353.5,200.7,335,200.7z"
      />
      <linearGradient
        id="SVGID_8_"
        gradientUnits="userSpaceOnUse"
        x1="396.1803"
        y1="178.3439"
        x2="371.2646"
        y2="144.0849"
      >
        <stop offset="0" />
        <stop offset="0.8025" />
      </linearGradient>
      <path
        className="st8"
        d="M395.5,220.4c12.5-14.2,20.1-32.8,20.1-53.2c0-44.5-36.1-80.6-80.6-80.6v47c18.5,0,33.6,15,33.6,33.6
	c0,8.1-2.9,15.5-7.7,21.3c-0.7,0.8-1.4,1.6-2.2,2.4"
      />
      <path
        className="st0"
        d="M496.1,86.6c-44.5,0-80.6,36.1-80.6,80.6s36.1,80.6,80.6,80.6c44.5,0,80.6-36.1,80.6-80.6
	S540.6,86.6,496.1,86.6z M496.1,200.7c-18.5,0-33.6-15-33.6-33.6c0-18.5,15-33.6,33.6-33.6s33.6,15,33.6,33.6
	C529.7,185.7,514.6,200.7,496.1,200.7z"
      />
      <linearGradient
        id="SVGID_9_"
        gradientUnits="userSpaceOnUse"
        x1="571.109"
        y1="167.6642"
        x2="548.2527"
        y2="138.0356"
      >
        <stop offset="0" />
        <stop offset="0.8025" />
      </linearGradient>
      <path
        className="st9"
        d="M576.6,85.6h-47h0v8.3c-10.2-4.7-21.6-7.3-33.6-7.3v47c18.5,0,33.6,15,33.6,33.6c0,9.2-3.7,17.5-9.6,23.5
	l34.9,31.5c13.5-14.4,21.7-33.7,21.7-55c0-0.3,0-0.6,0-0.9h0V85.6z"
      />
      <polygon className="st0" points="619.3,92.2 619.1,91.9 520.2,190.8 553.4,224.1 619.3,158.1 " />
      <linearGradient
        id="SVGID_10_"
        gradientUnits="userSpaceOnUse"
        x1="600.7264"
        y1="158.0043"
        x2="579.5865"
        y2="158.0043"
      >
        <stop offset="0" />
        <stop offset="0.8025" />
      </linearGradient>
      <polygon className="st10" points="619.3,92.2 619.1,91.9 520.2,190.8 553.4,224.1 619.3,158.1 " />
      <linearGradient
        id="SVGID_11_"
        gradientUnits="userSpaceOnUse"
        x1="435.7138"
        y1="155.7097"
        x2="466.4338"
        y2="193.3416"
      >
        <stop offset="0" />
        <stop offset="0.8025" />
      </linearGradient>
      <path
        className="st11"
        d="M496.1,200.7c-18.5,0-33.6-15-33.6-33.6c0-11,5.3-20.8,13.5-26.9l-38.5-28.4c-13.6,14.4-22,33.9-22,55.3
	c0,44.5,36.1,80.6,80.6,80.6"
      />
      <polygon className="st0" points="390.6,225.5 357.4,192.3 442.7,106.9 459.3,123.5 476,140.2 " />
      <path className="st0" d="M191.9,318h-78.5v-46.9h125.4v0C238.8,297,217.8,318,191.9,318z" />
      <path
        className="st0"
        d="M638.6,167.1V47.5c0-26-21-47-47-47h0l0,0v168.7h0c1.1,43.5,36.7,78.5,80.5,78.5v-47
	C653.6,200.7,638.6,185.7,638.6,167.1z"
      />
    </svg>
  </span>
);

const Logo = styled(LogoComponent)<LogoProps>`
  svg {
    height: ${props => sizes[props.size || 'sm']?.height};
    fill: ${props => variants[props.variant || 'gray600']?.fill};
  }
`;

export default Logo;
